module.exports = __webpack_public_path__ + "static/media/numero_de_casa.ba13a395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/numero_de_casa.svg
// module id = 1760
// module chunks = 0